/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-modal
    :id="modalNameAsId"
    :title="modalTitle"
    :modal-class="modalClass"
    :style="{ 'z-index' : 9993 }"
    v-model="showModal"
    ref="genericModal"
    centered
    v-bind="modalProps"
    @hidden="onHiddenModal"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <span class="title">{{ $t(modalTitle) }}</span>
      <button class="btn btn-icon btn-icon-small btn-icon-no-border btn-rounded" @click="close()">
        <svg class="o-icon"><use xlink:href="#close"></use></svg>
      </button>
    </template>
    <component :is="modalComponent.component" v-bind="modalComponent.props" />
  </b-modal>
</template>

<script>
import { EventBus, slugify } from '@/helpers'

export default {
  data () {
    return {
      dataClass: ''
    }
  },
  computed: {
    showModal: {
      get () {
        return !!this.modalObjectExist
      },
      set (newValue) {
        // return false and modal start closing
        return newValue
      }
    },
    modalClass () {
      return this.dataClass + ' bcm-modal'
    },
    modalObjectExist () {
      let obj = this.$store.getters['ui/getGenericModalComponent']
      if (obj && obj.componentToRender && obj.componentToRender.component) {
        return obj
      } else {
        return false
      }
    },
    modalComponent () {
      if (this.modalObjectExist) {
        return this.modalObjectExist.componentToRender
      } else {
        return false
      }
    },
    modalTitle () {
      if (this.modalObjectExist) {
        return this.modalObjectExist.title
      } else {
        return ''
      }
    },
    modalProps () {
      if (this.modalObjectExist) {
        return this.modalObjectExist.modalProps
      } else {
        return {}
      }
    },
    modalNameAsId () {
      if (this.modalComponent) {
        return `modal-${slugify(this.modalComponent.component.name)}`
      } else {
        return 'generic-modal'
      }
    }
  },
  methods: {
    close () {
      this.$bvModal.hide(this.modalNameAsId)
    },
    onHiddenModal () {
      // on modal close, empty component on it
      this.$store.commit('ui/setGenericModalComponent', {})
    }
  },
  mounted () {
    if (process.client) {
      EventBus.$on('genericModal:closeModal', this.close)
    }
  },
  destroyed () {
    EventBus.$off('genericModal:closeModal', this.close)
  }
}
</script>
